<script>
</script>

<main>
	<div class="hero is-fullheight-with-navbar is-dark">
		<div class="hero-body">
			<div class="container">
				<div class="columns is-centered has-text-centered">
					<div class="column is-three-quarters-tablet">
						<div class="banner">
							<figure class="image">
								<!-- svelte-ignore a11y-img-redundant-alt -->
								<img src="GachAni.png" alt="logo-image" />
							</figure>
							<p class="subtitle is-4">
								To find Anime recommendations, <a
									class="has-text-info"
									href="/#/ranking/all">browse the rankings</a
								>
								or
								<a class="has-text-info" href="/#/search"
									>search for something you like!</a
								>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</main>

<style>
	.banner {
		background-color: rgba(54, 54, 54, 0.7);
		padding-bottom: 3rem;
		padding: 0 3rem 3rem;
		border-radius: 10%;
	}
	.hero-body {
		background-color: #363636;
		background-image: url("data:image/svg+xml,%3Csvg width='52' height='26' viewBox='0 0 52 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23888888' fill-opacity='0.4'%3E%3Cpath d='M10 10c0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4v2c-3.314 0-6-2.686-6-6 0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6zm25.464-1.95l8.486 8.486-1.414 1.414-8.486-8.486 1.414-1.414z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
	}
</style>
